import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import VerticalNavbar from './components/VerticalNavbar';
import Home from './pages/Home';
import ManagePortfolio from './pages/ManagePortfolio';
import ManageSchemes from './pages/ManageSchemes';
import ManageEvents from './pages/ManageEvents';
import ManagePersons from './pages/ManagePersons';
import FounderManager from './pages/FounderManager';
import ManageInitiatives from './pages/ManageInitiatives';
import LoginForm from './pages/LoginForm';
import RegisterForm from './pages/RegisterForm';
import Profile from './pages/Profile';
import { useState, useEffect, createContext, useCallback } from 'react';
import PartnerUpload from './pages/PartnerManager';
import AdminDashboard from './pages/ManageCommunity';
import ManageReports from './pages/ManageReports';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext(null);

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkAuthStatus = useCallback(() => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      setIsLoggedIn(false);
      setLoading(false);
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setIsLoggedIn(false);
        alert('Your session has expired. Please log in again.');
      } else {
        setIsLoggedIn(true);
      }
    } catch (error) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setIsLoggedIn(false);
      console.error('Error decoding token:', error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    checkAuthStatus();
  }, [checkAuthStatus]);

  if (loading) {
    return <div>Loading...</div>; // Add a proper loading spinner here
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, checkAuthStatus }}>
      <Router>
        <div>
          {isLoggedIn ? (
            <div className="flex">
              <VerticalNavbar />
              <div className="px-5 flex-auto mt-2">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/manage-events" element={<ManageEvents />} />
                  <Route path="/manage-events" element={<ManageEvents />} />
                  <Route path="/manage-initiatives" element={<ManageInitiatives />} />
                  <Route path="/manage-portfolio" element={<ManagePortfolio />} />
                  <Route path="/manage-schemes" element={<ManageSchemes />} />
                  <Route path="/manage-persons" element={<ManagePersons />} />
                  <Route path="/manage-founders" element={<FounderManager />} />
                  <Route path="/manage-partners" element={<PartnerUpload />} />
                  <Route path="/manage-community" element={<AdminDashboard />} />
                  <Route path="/manage-reports" element={<ManageReports />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center h-screen">
              <Routes>
                <Route path="/login" element={<LoginForm />} />
                {/* <Route path="/register" element={<RegisterForm />} /> */}
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </div>
          )}
        </div>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;